module.exports = __webpack_public_path__ + "static/media/hi-IN.e97a5a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/hi-IN.png
// module id = 948
// module chunks = 0